import { Form, Input, DatePicker, Select, Upload, Avatar } from "antd";
import ImgCrop from 'antd-img-crop';
import LoadableButton from "../../../components/buttons/LoadableButton";
import Lock from "../../../assets/auth/Lock";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setloggedIn, setUserDetails } from "../../../store/Slices/userSlice";
import { ChangePasswordApi, ForgetOtp2FAApi, GetUserApi, LogoutApi, Request2faChangeApi, UpdateUserApi } from "../../../api/request/users";
import toast from "react-hot-toast";
import { GetAllCountryApi } from "../../../api/request/common";
import dayjs from "dayjs";
import { removeCookies } from "../../../services/Cookies";
import ModalComponent from "../../../components/modals/ModalComponent";
import { IpProvider } from "../../../services/IpProvider";
import { CameraOutlined } from '@ant-design/icons';
import { handleApiError } from "../../../utils/handleApiError";
import { resolveCountryIdFromUser } from "../../../utils/resolveProfileCountry";

export default function ProfileMobile() {

    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();
    const [formotp] = Form.useForm()

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);

    const [user, setUser] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingProfileUpdate, setIsLoadingProfileUpdate] = useState(false);
    const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
    const [countries, setCountries] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [FormData, setFormData] = useState({ email: "" });
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(0);
    const [ipAddress, setIpAddress] = useState('');
    const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
        const stored = localStorage.getItem("verifyWithOpt");
        return stored ? JSON.parse(stored) : false;
    });

    const getUser = async () => {
        try {
            const { data } = await GetUserApi(userDetails?._id);
            setUser(data?.data);
            const profile = data?.data;
            updateForm.setFieldsValue({
                FirstName: profile?.firstName,
                LastName: profile?.lastName,
                PhoneNo: profile?.phoneNo ?? '',
                ProfileImage: profile?.profileImage,
                DOB: profile?.dob ? dayjs(profile.dob) : '',
                ExpAsIb: profile?.expAsIb,
                City: profile?.city,
                CountryOfBirth: resolveCountryIdFromUser(profile, countries),
            });
            dispatch(setUserDetails({ ...userDetails, profileImage: data?.data?.profileImage }));
        } catch (error) {
        }
    }

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        updateForm.setFieldsValue({ profileImage: newFileList });
        if (newFileList.length === 0) {
            updateForm.setFieldsValue({ profileImage: null });
        }
    }

    const updateUserProfile = async (values) => {
        const extractOriginFileObj = (fileArray) => fileArray && fileArray[0]?.originFileObj;
        try {
            setIsLoadingProfileUpdate(true);
            let apiHeader = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };
            let params = {
                ...values,
                UserId: userDetails?._id,
                DOB: values['DOB'] ? dayjs(values['DOB']).format('MM/DD/YYYY') : '',
            };
            delete params.CountryOfBirth;
            if (values.profileImage && values.profileImage.length > 0) {
                params.ProfileImage = extractOriginFileObj(values.profileImage);
                delete params.profileImage;
            }
            const { data } = await UpdateUserApi({ ...params }, apiHeader);
            if (data?.success) {
                updateForm.resetFields();
                setFileList([]);
                toast.success(data?.message);
                getUser();
            }
            setIsLoadingProfileUpdate(false);
        } catch (error) {
            handleApiError(error);
            setIsLoadingProfileUpdate(false);
        }
    }

    const getContriens = async () => {
        try {
            const { data } = await GetAllCountryApi();
            if (data?.success) {
                setCountries(
                    data?.data?.map((item) => ({
                        ...item,
                        value: item?.id,
                        label: item?.countryName,
                    }))
                );
            }
        } catch (error) { }
    };

    const filterOption = (input, option) => {
        return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    };

    const beforeUpload = (file) => {
        const isAllowedType =
            file.type === "image/jpeg" ||
            file.type === "image/jpg" ||
            file.type === "image/png";
        if (!isAllowedType) {
            toast.error("You can only upload JPG/JPEG/PNG files!");
            return Upload.LIST_IGNORE;
        }
        const isLt800K = file.size / 1024 < 800;
        if (!isLt800K) {
            toast.error("Image must be smaller than 800KB!");
            return Upload.LIST_IGNORE;
        }
        return true;
    };

    const handleSubmit = async (values) => {
        const { oldPassword, newPassword, confirmPassword } = values;
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }
        const params = {
            id: userDetails?._id,
            oldPassword,
            password: newPassword,
            confirmPassword,
        };
        try {
            setIsLoading(true);
            const { data } = await ChangePasswordApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                logoutHandler();
            }
            setIsLoading(false);
        } catch (error) {
            handleApiError(error);
            setIsLoading(false);
        }
    };

    const getIpAddress = async () => {
        try {
            const { data } = await IpProvider();
            setIpAddress(data?.ip);
        } catch (error) { }
    }

    const logoutHandler = async () => {
        try {
            setIsLoading(true);
            const { data } = await LogoutApi({ ipAddress });
            if (data?.success) {
            }
            localStorage.clear();
            dispatch(setloggedIn(false));
            removeCookies("token");
            navigate("/");
            setIsLoading(false);
        } catch (err) {
            dispatch(setloggedIn(false));
            removeCookies("token");
            navigate("/");
        }
    };

    const open2FAHandle = async () => {
        setLoading(true);
        const success = await resendOTPHandler(!verifyWithOpt);
        setLoading(false);
        if (success) {
            setFormData({ otp: "" });
            setTimer(120);
            setIsOpen2FAModal(true);
        }
    };

    const resendOTPHandler = async (values) => {
        try {
            const { data } = await Request2faChangeApi(values);
            if (data?.success) {
                toast.success(data?.message);
                return true;
            }
        } catch (err) {
        }
        return false;
    };

    const handleSubmit2FA = async (values) => {
        const { otp } = values;
        if (!otp) {
            toast.error("OTP can not be empty.");
            return;
        }
        try {
            setIsLoading(true);
            let params = {
                userId: userDetails?._id,
                Otp: otp,
                isActiveFlag: !verifyWithOpt,
            };
            const { data } = await ForgetOtp2FAApi(params);
            if (data?.success) {
                toast.success(data?.message);
                const newValue = !verifyWithOpt;
                setVerifyWithOpt(newValue);
                localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
                formotp.resetFields();
                setIsOpen2FAModal(false);
            }
            setIsLoading(false);
        } catch (error) {
            handleApiError(error);
            setIsLoading(false);
        }
    };

    const onChange = (e) => {
        const newValue = e.target ? e.target.value : e;
        setFormData({ ...FormData, otp: newValue });
    };
    const sharedProps = {
        onChange,
    };

    const formatTime = (timer) => {
        const minutes = Math.floor(timer / 60);
        const remainingSeconds = timer % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    };

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("verifyWithOpt"));
        if (stored !== null) {
            setVerifyWithOpt(JSON.parse(stored));
        }
    }, []);

    useEffect(() => {
        getIpAddress();
        getUser();
        getContriens();
    }, []);

    useEffect(() => {
        if (!countries.length || !user?.firstName) return;
        const countryId = resolveCountryIdFromUser(user, countries);
        if (countryId != null) {
            updateForm.setFieldsValue({ CountryOfBirth: countryId });
        }
    }, [user, countries]);

    return (
        <div className="mobile-dashboard min-h-screen">
            <Form
                form={updateForm}
                layout="vertical"
                autoComplete="off"
                onFinish={updateUserProfile}
            >
                <div className="flex justify-center mb-8">
                    <div className="relative">
                        <Form.Item
                            name="profileImage"
                            valuePropName="fileList"
                            className="mb-0"
                        >
                            <ImgCrop rotationSlider showGrid>
                                <Upload
                                    fileList={fileList}
                                    name="profileImage"
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    onChange={handleChange}
                                >
                                    <div className="relative cursor-pointer">
                                        {fileList.length > 0 ? (
                                            <img
                                                src={URL.createObjectURL(fileList[0].originFileObj)}
                                                alt="avatar"
                                                className="w-[108px] h-[108px] rounded-full object-cover border-4 border-blue-200"
                                            />
                                        ) : user?.profileImage ? (
                                            <img
                                                src={user.profileImage}
                                                alt="avatar"
                                                className="w-[108px] h-[108px] rounded-full object-cover border-4 border-blue-200"
                                            />
                                        ) : (
                                            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center border-4 border-blue-200">
                                                <span className="text-white text-2xl font-semibold uppercase">
                                                    {user?.firstName?.charAt(0) || 'U'}
                                                    {user?.lastName?.charAt(0) || 'S'}
                                                </span>
                                            </div>
                                        )}

                                        {/* Camera Icon Overlay */}
                                        <div className="absolute bottom-0 right-0 w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                                            <CameraOutlined className="text-white text-xl" />
                                        </div>
                                    </div>
                                </Upload>
                            </ImgCrop>
                        </Form.Item>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white p-4 rounded-2xl">
                    <div className="flex gap-2">
                        <div className="w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">First Name</label>
                            <Form.Item name="FirstName" rules={[{ required: true, message: "Please enter first name." }]}>
                                <Input placeholder="First name" className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]" />
                            </Form.Item>
                        </div>

                        <div className="w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">Last Name</label>
                            <Form.Item name="LastName" rules={[{ required: true, message: "Please enter last name." }]}>
                                <Input placeholder="Last name" className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]" />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <div className="w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">Phone No.</label>
                            <Form.Item name="PhoneNo" rules={[{ required: true, message: "Please enter valid phone number." }]}>
                                <Input type="tel" placeholder="Phone no." className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]" />
                            </Form.Item>
                        </div>

                        <div className="input-white w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">Date Of Birth</label>
                            <Form.Item name="DOB">
                                <DatePicker
                                    placeholder="Date of birth"
                                    className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]"
                                    format='MM/DD/YYYY'
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div>
                        <label className="text-sm text-[#2F2B3DCC] font-medium">City</label>
                        <Form.Item name="City" >
                            <Input placeholder="City" className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]" />
                        </Form.Item>
                    </div>

                    <div className="flex gap-2">
                        <div className="w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">Experience As IB</label>
                            <Form.Item name="ExpAsIb">
                                <Input type="number" placeholder="Experience as ib" className="mt-1 w-full py-3 rounded-[14px] border-[#E2E8F0]" />
                            </Form.Item>
                        </div>

                        <div className="w-full">
                            <label className="text-sm text-[#2F2B3DCC] font-medium">Country</label>
                            <Form.Item name="CountryOfBirth" >
                                <Select disabled showSearch placeholder="Select a country" className="w-full mt-1 ant-select-selector-white country-profile-select" filterOption={filterOption} options={countries} popupClassName="custom-select-dropdown" dropdownAlign={{ offset: [0, 0] }} />
                            </Form.Item>
                        </div>
                    </div>

                </div>

                <div className="mt-6 flex gap-4">
                    <LoadableButton
                        type="submit"
                        className="bg-primary w-full text-sm text-white font-medium px-6 py-4 rounded-lg themeHover duration-500"
                        lable="Save changes"
                        loadingLable="Saving..."
                        isLoading={isLoadingProfileUpdate}
                        disabled={isLoadingProfileUpdate}
                    />
                </div>
            </Form >
        </div >
    );
}
